<template>
  <div class="container">
    <div class="item">
      <div>
        <span class="gray">患者姓名：</span>
        <span style="margin-right: 10px">{{ detail.nick_name }}</span
        ><el-tag type="success" v-if="detail.star_label_name">{{
          detail.star_label_name
        }}</el-tag>
      </div>
      <div style="margin: 0 50px">
        <span class="gray">性别：</span>
        <span v-if="detail.sex == 1">男</span>
        <span v-if="detail.sex == 2">女</span>
        <span v-if="detail.sex == 0">未知</span>
      </div>
      <div>
        <span class="gray">手机号：</span>
        <span>{{ detail.phone }}</span>
        <el-tag
          v-if="detail.is_abnormal"
          type="danger"
          size="mini"
          style="margin-left: 10px"
          >异常</el-tag
        >
        <el-button
          type="primary"
          plain
          size="medium"
          style="margin-left: 20px"
          @click="cancelUser"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('884') : false
          "
          >注销用户</el-button
        >
        <el-button
          v-if="detail.star_label_id == 1"
          type="primary"
          plain
          size="medium"
          style="margin-left: 20px"
          @click="updateUserCommission(1, 'cancelCommissionStar')"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1921') : false
          "
          >取消星推官</el-button
        >
        <el-button
          v-if="detail.star_label_id == 0"
          type="primary"
          plain
          size="medium"
          @click="updateUserCommission(0, 'joinCommissionStar')"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1922') : false
          "
          >成为星推官</el-button
        >
      </div>
    </div>
    <div class="item">
      <div>
        <span class="gray">注册时间：</span>
        <span>{{ detail.reg_time }}</span>
      </div>
      <div>
        <span style="color: #669961" v-if="detail.phone">已绑定</span>
      </div>
    </div>
    <div style="display: flex; align-items: center" class="item">
      <span class="gray">用户头像：</span>
      <img :src="detail.head_img" alt style="width: 60px; height: 60px" />
    </div>
    <div style="display: flex; align-items: center" v-if="detail.real_name">
      <span class="gray">实名信息：</span>
      <div class="idbox">
        <span style="margin-right: 30px">姓名：{{ detail.real_name }}</span>
        <span style="margin-right: 30px"
          >证件类型：{{ detail.id_card_type | idCardTypeText }}</span
        >
        <span>身份证号：{{ detail.id_card }}</span>
      </div>
    </div>

    <div
      style="display: flex; align-items: center; margin-top: 20px"
      class="item"
    >
      <span class="gray">平台渠道：</span>
      <div>{{ detail.platform_channel }}</div>
    </div>

    <div
      style="display: flex; align-items: center; margin-top: 20px"
      class="item"
    >
      <span class="gray">是否为歧黄学堂用户：</span>
      <div>{{ !detail.is_school ? "否" : "是" }}</div>
    </div>

    <div
      v-if="!detail.study"
      style="display: flex; align-items: center; margin-top: 20px"
      class="item"
    >
      <span class="gray">是否是小蓝本用户：</span>
      <div>{{ !detail.is_saas ? "否" : "是" }}</div>
    </div>

    <template v-if="detail.is_saas == 1">
      <div
        v-for="(item, index) in detail.clinic_list"
        :key="index"
        style="display: flex; align-items: center; margin-top: 20px"
        class="item"
      >
        <span class="gray">所在诊所：</span>
        <div>{{ item.saas_clinic_name }}</div>

        <span class="gray">&nbsp;&nbsp;姓名：</span>
        <div>{{ item.user_name }}</div>
      </div>
    </template>

    <div
      v-if="detail.address"
      style="display: flex; align-items: center"
      class="item"
    >
      <span class="gray">收货地区：</span>
      <div>{{ detail.address }}</div>
    </div>
    <div style="display: flex; align-items: center" class="item">
      <span class="gray">IP所在地：</span>
      <div>{{ detail.ip }}</div>
    </div>
    <div style="display: flex; align-items: center" class="item">
      <span class="gray">用户来源：</span>
      <div>{{ detail.user_from_str }}</div>
    </div>

    <div style="display: flex; align-items: center" class="item">
      <span class="gray">关联医生：</span>
      <div>{{ detail.related_doctor }}</div>
    </div>

    <div style="display: flex; align-items: center" class="item">
      <span class="gray">绑定医生：</span>
      <el-tag
        v-if="detail.use_relationship && detail.use_relationship == 1"
        size="small"
        type="danger"
        style="margin-right: 20px"
        >分佣医生有效</el-tag
      >
      <div>{{ detail.bind_doctor }}</div>
    </div>

    <div style="display: flex; align-items: center" class="item">
      <span class="gray">邀请人（星推官）：</span>
      <el-tag
        v-if="detail.phone && detail.share_phone"
        size="small"
        type="danger"
        style="margin-right: 20px"
        >分佣有效</el-tag
      >
      <div style="margin-right: 20px">{{ detail.share_nick_name }}</div>
      <div>{{ detail.share_phone }}</div>
    </div>
  </div>
</template>
<script>
import patient from "../../../api/patient";
import platform from "../../../api/platform";
export default {
  data() {
    return {
      detail: {},
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  filters: {
    idCardTypeText(val) {
      switch (val) {
        case 1:
          return "大陆身份证";
        case 2:
          return "香港身份证";
        case 3:
          return "澳门身份证";
      }
    },
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      const loading = this.$loading();
      let user_id = this.$route.query.user_id;
      patient
        .userItem({ user_id })
        .then((res) => {
          if (res.code == 0) {
            this.detail = res.data.info;
            this.detail.reg_time = platform.timestampToTime(
              this.detail.reg_time
            );
            loading.close();
          }
        })
        .catch((err) => loading.close());
    },
    //注销用户
    cancelUser() {
      this.$confirm("该操作不可恢复确定要注销该用户吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let user_id = this.$route.query.user_id;
          this.axios
            .post("platform/patient/saveUserItemOpenId", { user_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("用户已注销");
                this.getDetail();
              }
            });
        })
        .catch(() => {});
    },
    //成为取消星推官
    updateUserCommission(type, interfaceName) {
      let params = {
        user_id: this.$route.query.user_id,
      };
      let msg = "确认取消星推官？";
      if (!type) {
        msg = "确认成为星推官？";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          patient[interfaceName](params).then((res) => {
            if (res.code == 0) {
              this.$message.success("操作成功");
              this.getDetail();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  text-align: left;
  padding: 20px;
  box-sizing: border-box;
}
.item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.gray {
  color: #747981;
}
.idbox {
  color: #747981;
  padding: 10px 30px;
  border: solid 1px #e1e3e9;
}
</style>
